__turbopack_context__.v({
  "defaultStyle": "kFP8aG_defaultStyle",
});
